import { render, staticRenderFns } from "./AccountSettingGeneral.vue?vue&type=template&id=b787c768&"
import script from "./AccountSettingGeneral.vue?vue&type=script&lang=js&"
export * from "./AccountSettingGeneral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports